import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  erro: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): State {
    return { erro };
  }

  override componentDidCatch(erro: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', erro, info.componentStack);
  }

  override render() {
    if (!this.state.erro) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-semibold">Algo deu errado</h1>
          <p className="mt-3 text-tinta-suave">
            A página encontrou um erro inesperado. Recarregue para tentar de novo.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 rounded-md bg-destaque px-6 py-3 text-sm font-medium text-papel"
          >
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
